var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#898E99",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5587_32715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0323 19.1392C13.3297 19.1392 12.7032 19.0099 12.1531 18.7514C11.6062 18.4929 11.172 18.1366 10.8505 17.6825C10.529 17.2285 10.3616 16.7081 10.3484 16.1214H12.4364C12.4596 16.5159 12.6254 16.8357 12.9336 17.081C13.2418 17.3262 13.6081 17.4489 14.0323 17.4489C14.3704 17.4489 14.6687 17.3743 14.9272 17.2251C15.189 17.0727 15.3929 16.8622 15.5387 16.5938C15.6879 16.322 15.7624 16.0104 15.7624 15.6591C15.7624 15.3011 15.6862 14.9863 15.5337 14.7145C15.3846 14.4427 15.1774 14.2306 14.9123 14.0781C14.6471 13.9257 14.3439 13.8478 14.0025 13.8445C13.7042 13.8445 13.4142 13.9058 13.1325 14.0284C12.854 14.151 12.637 14.3184 12.4812 14.5305L10.5671 14.1875L11.0494 8.81818H17.2738V10.5781H12.8242L12.5607 13.1286H12.6204C12.7994 12.8767 13.0695 12.6679 13.4308 12.5021C13.792 12.3364 14.1964 12.2536 14.6438 12.2536C15.257 12.2536 15.8039 12.3977 16.2844 12.6861C16.765 12.9744 17.1445 13.3705 17.4229 13.8743C17.7013 14.3748 17.8389 14.9515 17.8356 15.6044C17.8389 16.2905 17.6798 16.9003 17.3583 17.4339C17.0401 17.9643 16.5943 18.3819 16.021 18.6868C15.4509 18.9884 14.788 19.1392 14.0323 19.1392Z",
    fill: "#898E99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5587_32715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 22,
    fill: "white",
    transform: "translate(9 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefine);
export default __webpack_public_path__ + "static/media/Define.bd86e8ee64222b7dc1c8c5257ffbcfb1.svg";
export { ForwardRef as ReactComponent };